import { render } from "./CategoryIndex.vue?vue&type=template&id=56343788"
import script from "./CategoryIndex.vue?vue&type=script&lang=js"
export * from "./CategoryIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__